import { takeLatest } from 'redux-saga/effects';
import * as actions from '~/ducks/user-roles/actions';
import callRequestSaga from '~/sagas/utils/request-saga';
import UserManagementAPI from '~/api/user-management-api';

export function* getAvailableRoles() {
  yield* callRequestSaga(
    UserManagementAPI.getAvailableRoles,
    actions.getAvailableRoles.actions
  );
}

export function* getAvailableRolesSaga() {
  yield takeLatest(actions.getAvailableRoles.type, getAvailableRoles);
}

export default [getAvailableRolesSaga];
